import * as yup from 'yup';
import {
  checkFiscalNumberControlChar,
  fiscalNumberRegex,
} from '../utils/checkFiscalNumber.ts';
import { remapOmocodeDigit } from '../utils/remapOmocodeDigit.ts';

declare module 'yup' {
  interface StringSchema {
    /**
     * Valida la stringa come codice fiscale.
     */
    fiscalNumber<T extends string>(errorMessagge?: string): StringSchema<T>;
  }
}

yup.addMethod(
  yup.string,
  'fiscalNumber',
  function (this: yup.StringSchema, errorMessagge?: string) {
    return this.uppercase().test(
      'fiscal-number-check',
      errorMessagge ?? 'Il codice fiscale non è valido',
      fiscalNumber => {
        if (!fiscalNumber) return true;
        // Check sul formato: il remap riporta a cifra le lettere omocodiche,
        // così il formato accetta anche i codici omocodici
        if (!fiscalNumberRegex.test(remapOmocodeDigit(fiscalNumber))) {
          return false;
        }
        // Check cifra di controllo (sul codice originale, non remappato)
        return checkFiscalNumberControlChar(fiscalNumber);
      },
    );
  },
);
